module.exports = __webpack_public_path__ + "img/news15_5.13e5ae18.jpg";